import React from "react";

// Components
import { withTranslation } from "react-i18next";
import User from "../../types/User";
import ButtonLink from "../Button/ButtonLink";

interface ManageAccountLinkProps {
  user: User;
}

class ManageAccountLink extends React.Component<ManageAccountLinkProps | any, any> {
  render() {
    const { user, className, manageAccountProps, t } = this.props;
    return user ? (
      <div {...manageAccountProps} className={["profile__manage-account", className].join(" ")}>
        <p>
          <small>{t("manageAccountExplaination")}:</small>
        </p>
        <ButtonLink text="Manage my account" to={`/profile/account`} />
      </div>
    ) : null;
  }
}

export default withTranslation()(ManageAccountLink);
